import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Circle, Star } from 'lucide-react';
export type PlanId = 'esencial' | 'megapack';
export const PLANS: Record<PlanId, {
  id: PlanId;
  name: string;
  desc: string;
  price: string;
  oldPrice: string;
  url: string;
  popular?: boolean;
}> = {
  esencial: {
    id: 'esencial',
    name: 'Kit Esencial',
    desc: '6 tomos + 3 bonos',
    price: '$19.990',
    oldPrice: '$27.990',
    url: 'https://checkout.solucionesya.shop/cart/48891990114552:1'
  },
  megapack: {
    id: 'megapack',
    name: 'Megapack',
    desc: '8 tomos + 3 bonos · incluye Pediatría y Braquiterapia',
    price: '$27.990',
    oldPrice: '$35.990',
    url: 'https://checkout.solucionesya.shop/cart/48891990409464:1',
    popular: true
  }
};
interface PlanSelectorProps {
  selected: PlanId;
  onSelect: (id: PlanId) => void;
  ctaId?: string;
}
export function PlanSelector({
  selected,
  onSelect,
  ctaId
}: PlanSelectorProps) {
  const active = PLANS[selected];
  return <div className="max-w-3xl mx-auto" data-id="element-141">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mb-6" data-id="element-142">
        {Object.values(PLANS).map(plan => {
        const isSelected = selected === plan.id;
        return <motion.button key={plan.id} type="button" onClick={() => onSelect(plan.id)} whileTap={{
          scale: 0.98
        }} whileHover={{
          y: -3
        }} aria-pressed={isSelected} className={`relative text-left rounded-2xl p-4 sm:p-5 border-2 transition-colors focus:outline-none focus:ring-2 focus:ring-amber-400 ${isSelected ? plan.popular ? 'border-amber-500 bg-slate-800 shadow-lg shadow-amber-900/20' : 'border-teal-500 bg-slate-800' : 'border-slate-700 bg-slate-800/40 hover:border-slate-600'}`} data-id="element-143">
              {plan.popular && <span className="absolute -top-2.5 left-1/2 -translate-x-1/2 bg-amber-500 text-slate-900 font-bold px-3 py-0.5 rounded-full text-[10px] sm:text-xs flex items-center gap-1 whitespace-nowrap shadow" data-id="element-144">
                  <Star className="w-2.5 h-2.5 sm:w-3 sm:h-3 fill-slate-900" data-id="element-145" />{' '}
                  Más Elegido
                </span>}
              <div className="flex items-start justify-between gap-3" data-id="element-146">
                <div className="flex items-start gap-2.5 min-w-0" data-id="element-147">
                  {isSelected ? <CheckCircle2 className={`w-5 h-5 shrink-0 mt-0.5 ${plan.popular ? 'text-amber-500' : 'text-teal-500'}`} data-id="element-148" /> : <Circle className="w-5 h-5 shrink-0 mt-0.5 text-slate-500" data-id="element-149" />}
                  <div className="min-w-0" data-id="element-150">
                    <p className="font-bold text-white text-sm sm:text-base leading-tight" data-id="element-151">
                      {plan.name}
                    </p>
                    <p className="text-[11px] sm:text-xs text-slate-400 leading-snug mt-0.5" data-id="element-152">
                      {plan.desc}
                    </p>
                  </div>
                </div>
                <div className="text-right shrink-0" data-id="element-153">
                  <span className="block text-slate-500 line-through text-[11px] sm:text-xs" data-id="element-154">
                    {plan.oldPrice}
                  </span>
                  <span className={`block font-extrabold text-lg sm:text-2xl ${plan.popular ? 'text-amber-400' : 'text-white'}`} data-id="element-155">
                    {plan.price}
                  </span>
                </div>
              </div>
            </motion.button>;
      })}
      </div>

      <div id={ctaId} className="relative max-w-md mx-auto scroll-mt-24" data-id="element-156">
        {active.popular && <div className="absolute inset-0 bg-amber-500 rounded-xl blur opacity-40 animate-pulse" data-id="element-157"></div>}
        <motion.a key={active.id} href={active.url} whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className={`relative flex w-full items-center justify-center text-center font-bold text-base sm:text-lg py-4 px-6 rounded-xl shadow-lg transition-colors ${active.popular ? 'bg-amber-500 hover:bg-amber-400 text-slate-900' : 'bg-teal-500 hover:bg-teal-400 text-white'}`} data-id="element-158">
          💥 COMPRAR {active.name.toUpperCase()} · {active.price}
        </motion.a>
      </div>
    </div>;
}